/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FavoriteStoresDto } from '../model/favoriteStoresDto';
import { StoreForOrderDto } from '../model/storeForOrderDto';
import { StoreGetOneDto } from '../model/storeGetOneDto';
import { StoreInfoDto } from '../model/storeInfoDto';
import { StoreNewPswDto } from '../model/storeNewPswDto';
import { StoreOutputDto } from '../model/storeOutputDto';
import { StoreRequestDto } from '../model/storeRequestDto';
import { StoreResponseDto } from '../model/storeResponseDto';
import { StoreTotalDto } from '../model/storeTotalDto';
import { StoreViewUserDto } from '../model/storeViewUserDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class StoreService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdstore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreAddToTrendingPut(cdstore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreOutputDto>;
    public apiStoreAddToTrendingPut(cdstore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreOutputDto>>;
    public apiStoreAddToTrendingPut(cdstore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreOutputDto>>;
    public apiStoreAddToTrendingPut(cdstore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdstore !== undefined && cdstore !== null) {
            queryParameters = queryParameters.set('cdstore', <any>cdstore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreOutputDto>('put',`${this.basePath}/api/Store/AddToTrending`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreAdminLoginGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreResponseDto>;
    public apiStoreAdminLoginGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreResponseDto>>;
    public apiStoreAdminLoginGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreResponseDto>>;
    public apiStoreAdminLoginGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreResponseDto>('get',`${this.basePath}/api/Store/AdminLogin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdBanner 
     * @param cdCity 
     * @param cdUser 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreBannerStoresInCityGet(cdBanner?: number, cdCity?: number, cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<StoreViewUserDto>>;
    public apiStoreBannerStoresInCityGet(cdBanner?: number, cdCity?: number, cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreViewUserDto>>>;
    public apiStoreBannerStoresInCityGet(cdBanner?: number, cdCity?: number, cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreViewUserDto>>>;
    public apiStoreBannerStoresInCityGet(cdBanner?: number, cdCity?: number, cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdBanner !== undefined && cdBanner !== null) {
            queryParameters = queryParameters.set('cdBanner', <any>cdBanner);
        }
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreViewUserDto>>('get',`${this.basePath}/api/Store/BannerStoresInCity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreChangePswPut(body?: StoreNewPswDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiStoreChangePswPut(body?: StoreNewPswDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiStoreChangePswPut(body?: StoreNewPswDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiStoreChangePswPut(body?: StoreNewPswDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Store/ChangePsw`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdstore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreDeleteStoreDelete(cdstore?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiStoreDeleteStoreDelete(cdstore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiStoreDeleteStoreDelete(cdstore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiStoreDeleteStoreDelete(cdstore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdstore !== undefined && cdstore !== null) {
            queryParameters = queryParameters.set('cdstore', <any>cdstore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/api/Store/DeleteStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param cdCity 
     * @param cdStoreType 
     * @param dsName 
     * @param dsEmail 
     * @param dsPhone 
     * @param dsAddress 
     * @param dsPostalCode 
     * @param dsNewImg 
     * @param image 
     * @param dsNewPassword 
     * @param dtOpeningTime 
     * @param dtClosingTime 
     * @param dtOpeningTime2 
     * @param dtClosingTime2 
     * @param nmDeliveryTime 
     * @param qtPersonCost 
     * @param qtLatitude 
     * @param qtLongitude 
     * @param qtNewCommission 
     * @param dsNewLogo 
     * @param logoImage 
     * @param dsSlogan 
     * @param additionalImages 
     * @param itemImagesUrl 
     * @param dsApiMeli 
     * @param dsMeliPublicKey 
     * @param qtDeliveryValue 
     * @param nmMaximumKmDelivery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreEditStorePutForm(cdStore?: number, cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsNewImg?: string, image?: Blob, dsNewPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtNewCommission?: number, dsNewLogo?: string, logoImage?: Blob, dsSlogan?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreOutputDto>;
    public apiStoreEditStorePutForm(cdStore?: number, cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsNewImg?: string, image?: Blob, dsNewPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtNewCommission?: number, dsNewLogo?: string, logoImage?: Blob, dsSlogan?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreOutputDto>>;
    public apiStoreEditStorePutForm(cdStore?: number, cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsNewImg?: string, image?: Blob, dsNewPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtNewCommission?: number, dsNewLogo?: string, logoImage?: Blob, dsSlogan?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreOutputDto>>;
    public apiStoreEditStorePutForm(cdStore?: number, cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsNewImg?: string, image?: Blob, dsNewPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtNewCommission?: number, dsNewLogo?: string, logoImage?: Blob, dsSlogan?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






























        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdStore !== undefined) {
            formParams = formParams.append('CdStore', <any>cdStore) as any || formParams;
        }
        if (cdCity !== undefined) {
            formParams = formParams.append('CdCity', <any>cdCity) as any || formParams;
        }
        if (cdStoreType !== undefined) {
            formParams = formParams.append('CdStoreType', <any>cdStoreType) as any || formParams;
        }
        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsEmail !== undefined) {
            formParams = formParams.append('DsEmail', <any>dsEmail) as any || formParams;
        }
        if (dsPhone !== undefined) {
            formParams = formParams.append('DsPhone', <any>dsPhone) as any || formParams;
        }
        if (dsAddress !== undefined) {
            formParams = formParams.append('DsAddress', <any>dsAddress) as any || formParams;
        }
        if (dsPostalCode !== undefined) {
            formParams = formParams.append('DsPostalCode', <any>dsPostalCode) as any || formParams;
        }
        if (dsNewImg !== undefined) {
            formParams = formParams.append('DsNewImg', <any>dsNewImg) as any || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) as any || formParams;
        }
        if (dsNewPassword !== undefined) {
            formParams = formParams.append('DsNewPassword', <any>dsNewPassword) as any || formParams;
        }
        if (dtOpeningTime !== undefined) {
            formParams = formParams.append('DtOpeningTime', <any>dtOpeningTime) as any || formParams;
        }
        if (dtClosingTime !== undefined) {
            formParams = formParams.append('DtClosingTime', <any>dtClosingTime) as any || formParams;
        }
        if (dtOpeningTime2 !== undefined) {
            formParams = formParams.append('DtOpeningTime2', <any>dtOpeningTime2) as any || formParams;
        }
        if (dtClosingTime2 !== undefined) {
            formParams = formParams.append('DtClosingTime2', <any>dtClosingTime2) as any || formParams;
        }
        if (nmDeliveryTime !== undefined) {
            formParams = formParams.append('NmDeliveryTime', <any>nmDeliveryTime) as any || formParams;
        }
        if (qtPersonCost !== undefined) {
            formParams = formParams.append('QtPersonCost', <any>qtPersonCost) as any || formParams;
        }
        if (qtLatitude !== undefined) {
            formParams = formParams.append('QtLatitude', <any>qtLatitude) as any || formParams;
        }
        if (qtLongitude !== undefined) {
            formParams = formParams.append('QtLongitude', <any>qtLongitude) as any || formParams;
        }
        if (qtNewCommission !== undefined) {
            formParams = formParams.append('QtNewCommission', <any>qtNewCommission) as any || formParams;
        }
        if (dsNewLogo !== undefined) {
            formParams = formParams.append('DsNewLogo', <any>dsNewLogo) as any || formParams;
        }
        if (logoImage !== undefined) {
            formParams = formParams.append('LogoImage', <any>logoImage) as any || formParams;
        }
        if (dsSlogan !== undefined) {
            formParams = formParams.append('DsSlogan', <any>dsSlogan) as any || formParams;
        }
        if (additionalImages) {
            additionalImages.forEach((element) => {
                formParams = formParams.append('AdditionalImages', <any>element) as any || formParams;
            })
        }
        if (itemImagesUrl) {
            itemImagesUrl.forEach((element) => {
                formParams = formParams.append('ItemImagesUrl', <any>element) as any || formParams;
            })
        }
        if (dsApiMeli !== undefined) {
            formParams = formParams.append('DsApiMeli', <any>dsApiMeli) as any || formParams;
        }
        if (dsMeliPublicKey !== undefined) {
            formParams = formParams.append('DsMeliPublicKey', <any>dsMeliPublicKey) as any || formParams;
        }
        if (qtDeliveryValue !== undefined) {
            formParams = formParams.append('QtDeliveryValue', <any>qtDeliveryValue) as any || formParams;
        }
        if (nmMaximumKmDelivery !== undefined) {
            formParams = formParams.append('NmMaximumKmDelivery', <any>nmMaximumKmDelivery) as any || formParams;
        }

        return this.httpClient.request<StoreOutputDto>('put',`${this.basePath}/api/Store/EditStore`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdstore 
     * @param state 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreEnableOrDisableStorePut(cdstore?: number, state?: boolean, observe?: 'body', reportProgress?: boolean): Observable<StoreOutputDto>;
    public apiStoreEnableOrDisableStorePut(cdstore?: number, state?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreOutputDto>>;
    public apiStoreEnableOrDisableStorePut(cdstore?: number, state?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreOutputDto>>;
    public apiStoreEnableOrDisableStorePut(cdstore?: number, state?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdstore !== undefined && cdstore !== null) {
            queryParameters = queryParameters.set('cdstore', <any>cdstore);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreOutputDto>('put',`${this.basePath}/api/Store/EnableOrDisableStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetAllStoresGet(observe?: 'body', reportProgress?: boolean): Observable<Array<StoreOutputDto>>;
    public apiStoreGetAllStoresGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreOutputDto>>>;
    public apiStoreGetAllStoresGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreOutputDto>>>;
    public apiStoreGetAllStoresGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreOutputDto>>('get',`${this.basePath}/api/Store/GetAllStores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param dsCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetIdentifiersStoreGet(dsCode?: string, observe?: 'body', reportProgress?: boolean): Observable<StoreGetOneDto>;
    public apiStoreGetIdentifiersStoreGet(dsCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreGetOneDto>>;
    public apiStoreGetIdentifiersStoreGet(dsCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreGetOneDto>>;
    public apiStoreGetIdentifiersStoreGet(dsCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dsCode !== undefined && dsCode !== null) {
            queryParameters = queryParameters.set('dsCode', <any>dsCode);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreGetOneDto>('get',`${this.basePath}/api/Store/GetIdentifiersStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdstore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetOneStoreGet(cdstore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreGetOneDto>;
    public apiStoreGetOneStoreGet(cdstore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreGetOneDto>>;
    public apiStoreGetOneStoreGet(cdstore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreGetOneDto>>;
    public apiStoreGetOneStoreGet(cdstore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdstore !== undefined && cdstore !== null) {
            queryParameters = queryParameters.set('cdstore', <any>cdstore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreGetOneDto>('get',`${this.basePath}/api/Store/GetOneStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetStoreForOrderGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreForOrderDto>;
    public apiStoreGetStoreForOrderGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreForOrderDto>>;
    public apiStoreGetStoreForOrderGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreForOrderDto>>;
    public apiStoreGetStoreForOrderGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreForOrderDto>('get',`${this.basePath}/api/Store/GetStoreForOrder`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetStoreInfoGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreInfoDto>;
    public apiStoreGetStoreInfoGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreInfoDto>>;
    public apiStoreGetStoreInfoGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreInfoDto>>;
    public apiStoreGetStoreInfoGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreInfoDto>('get',`${this.basePath}/api/Store/GetStoreInfo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetStoreStartGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreTotalDto>;
    public apiStoreGetStoreStartGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreTotalDto>>;
    public apiStoreGetStoreStartGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreTotalDto>>;
    public apiStoreGetStoreStartGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreTotalDto>('get',`${this.basePath}/api/Store/GetStoreStart`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStoreType 
     * @param cdCity 
     * @param cdUser 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreGetStoresByStoreTypeGet(cdStoreType?: number, cdCity?: number, cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<StoreViewUserDto>>;
    public apiStoreGetStoresByStoreTypeGet(cdStoreType?: number, cdCity?: number, cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreViewUserDto>>>;
    public apiStoreGetStoresByStoreTypeGet(cdStoreType?: number, cdCity?: number, cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreViewUserDto>>>;
    public apiStoreGetStoresByStoreTypeGet(cdStoreType?: number, cdCity?: number, cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStoreType !== undefined && cdStoreType !== null) {
            queryParameters = queryParameters.set('cdStoreType', <any>cdStoreType);
        }
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreViewUserDto>>('get',`${this.basePath}/api/Store/GetStoresByStoreType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCity 
     * @param cdStoreType 
     * @param dsName 
     * @param dsEmail 
     * @param dsPhone 
     * @param dsAddress 
     * @param dsPostalCode 
     * @param dsImg 
     * @param image 
     * @param dsPassword 
     * @param dtOpeningTime 
     * @param dtClosingTime 
     * @param dtOpeningTime2 
     * @param dtClosingTime2 
     * @param nmDeliveryTime 
     * @param qtPersonCost 
     * @param qtLatitude 
     * @param qtLongitude 
     * @param qtAppCommission 
     * @param dsSlogan 
     * @param dsLogo 
     * @param logoImage 
     * @param dsCode 
     * @param additionalImages 
     * @param itemImagesUrl 
     * @param dsApiMeli 
     * @param dsMeliPublicKey 
     * @param qtDeliveryValue 
     * @param nmMaximumKmDelivery 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreNewStorePostForm(cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsImg?: string, image?: Blob, dsPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtAppCommission?: number, dsSlogan?: string, dsLogo?: string, logoImage?: Blob, dsCode?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiStoreNewStorePostForm(cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsImg?: string, image?: Blob, dsPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtAppCommission?: number, dsSlogan?: string, dsLogo?: string, logoImage?: Blob, dsCode?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiStoreNewStorePostForm(cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsImg?: string, image?: Blob, dsPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtAppCommission?: number, dsSlogan?: string, dsLogo?: string, logoImage?: Blob, dsCode?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiStoreNewStorePostForm(cdCity?: number, cdStoreType?: number, dsName?: string, dsEmail?: string, dsPhone?: string, dsAddress?: string, dsPostalCode?: string, dsImg?: string, image?: Blob, dsPassword?: string, dtOpeningTime?: Date, dtClosingTime?: Date, dtOpeningTime2?: Date, dtClosingTime2?: Date, nmDeliveryTime?: number, qtPersonCost?: number, qtLatitude?: number, qtLongitude?: number, qtAppCommission?: number, dsSlogan?: string, dsLogo?: string, logoImage?: Blob, dsCode?: string, additionalImages?: Array<Blob>, itemImagesUrl?: Array<string>, dsApiMeli?: string, dsMeliPublicKey?: string, qtDeliveryValue?: number, nmMaximumKmDelivery?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






























        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdCity !== undefined) {
            formParams = formParams.append('CdCity', <any>cdCity) as any || formParams;
        }
        if (cdStoreType !== undefined) {
            formParams = formParams.append('CdStoreType', <any>cdStoreType) as any || formParams;
        }
        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsEmail !== undefined) {
            formParams = formParams.append('DsEmail', <any>dsEmail) as any || formParams;
        }
        if (dsPhone !== undefined) {
            formParams = formParams.append('DsPhone', <any>dsPhone) as any || formParams;
        }
        if (dsAddress !== undefined) {
            formParams = formParams.append('DsAddress', <any>dsAddress) as any || formParams;
        }
        if (dsPostalCode !== undefined) {
            formParams = formParams.append('DsPostalCode', <any>dsPostalCode) as any || formParams;
        }
        if (dsImg !== undefined) {
            formParams = formParams.append('DsImg', <any>dsImg) as any || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) as any || formParams;
        }
        if (dsPassword !== undefined) {
            formParams = formParams.append('DsPassword', <any>dsPassword) as any || formParams;
        }
        if (dtOpeningTime !== undefined) {
            formParams = formParams.append('DtOpeningTime', <any>dtOpeningTime) as any || formParams;
        }
        if (dtClosingTime !== undefined) {
            formParams = formParams.append('DtClosingTime', <any>dtClosingTime) as any || formParams;
        }
        if (dtOpeningTime2 !== undefined) {
            formParams = formParams.append('DtOpeningTime2', <any>dtOpeningTime2) as any || formParams;
        }
        if (dtClosingTime2 !== undefined) {
            formParams = formParams.append('DtClosingTime2', <any>dtClosingTime2) as any || formParams;
        }
        if (nmDeliveryTime !== undefined) {
            formParams = formParams.append('NmDeliveryTime', <any>nmDeliveryTime) as any || formParams;
        }
        if (qtPersonCost !== undefined) {
            formParams = formParams.append('QtPersonCost', <any>qtPersonCost) as any || formParams;
        }
        if (qtLatitude !== undefined) {
            formParams = formParams.append('QtLatitude', <any>qtLatitude) as any || formParams;
        }
        if (qtLongitude !== undefined) {
            formParams = formParams.append('QtLongitude', <any>qtLongitude) as any || formParams;
        }
        if (qtAppCommission !== undefined) {
            formParams = formParams.append('QtAppCommission', <any>qtAppCommission) as any || formParams;
        }
        if (dsSlogan !== undefined) {
            formParams = formParams.append('DsSlogan', <any>dsSlogan) as any || formParams;
        }
        if (dsLogo !== undefined) {
            formParams = formParams.append('DsLogo', <any>dsLogo) as any || formParams;
        }
        if (logoImage !== undefined) {
            formParams = formParams.append('LogoImage', <any>logoImage) as any || formParams;
        }
        if (dsCode !== undefined) {
            formParams = formParams.append('DsCode', <any>dsCode) as any || formParams;
        }
        if (additionalImages) {
            additionalImages.forEach((element) => {
                formParams = formParams.append('AdditionalImages', <any>element) as any || formParams;
            })
        }
        if (itemImagesUrl) {
            itemImagesUrl.forEach((element) => {
                formParams = formParams.append('ItemImagesUrl', <any>element) as any || formParams;
            })
        }
        if (dsApiMeli !== undefined) {
            formParams = formParams.append('DsApiMeli', <any>dsApiMeli) as any || formParams;
        }
        if (dsMeliPublicKey !== undefined) {
            formParams = formParams.append('DsMeliPublicKey', <any>dsMeliPublicKey) as any || formParams;
        }
        if (qtDeliveryValue !== undefined) {
            formParams = formParams.append('QtDeliveryValue', <any>qtDeliveryValue) as any || formParams;
        }
        if (nmMaximumKmDelivery !== undefined) {
            formParams = formParams.append('NmMaximumKmDelivery', <any>nmMaximumKmDelivery) as any || formParams;
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/Store/NewStore`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCity 
     * @param cdUser 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreNewestStoresByCityGet(cdCity?: number, cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<StoreViewUserDto>>;
    public apiStoreNewestStoresByCityGet(cdCity?: number, cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreViewUserDto>>>;
    public apiStoreNewestStoresByCityGet(cdCity?: number, cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreViewUserDto>>>;
    public apiStoreNewestStoresByCityGet(cdCity?: number, cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('CdCity', <any>cdCity);
        }
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreViewUserDto>>('get',`${this.basePath}/api/Store/NewestStoresByCity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdstore 
     * @param state 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreOpenOrCloseStorePut(cdstore?: number, state?: boolean, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiStoreOpenOrCloseStorePut(cdstore?: number, state?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiStoreOpenOrCloseStorePut(cdstore?: number, state?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiStoreOpenOrCloseStorePut(cdstore?: number, state?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdstore !== undefined && cdstore !== null) {
            queryParameters = queryParameters.set('cdstore', <any>cdstore);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Store/OpenOrCloseStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdstore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreRemoveFromTrendingPut(cdstore?: number, observe?: 'body', reportProgress?: boolean): Observable<StoreOutputDto>;
    public apiStoreRemoveFromTrendingPut(cdstore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreOutputDto>>;
    public apiStoreRemoveFromTrendingPut(cdstore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreOutputDto>>;
    public apiStoreRemoveFromTrendingPut(cdstore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdstore !== undefined && cdstore !== null) {
            queryParameters = queryParameters.set('cdstore', <any>cdstore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoreOutputDto>('put',`${this.basePath}/api/Store/RemoveFromTrending`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreStoreLoginPost(body?: StoreRequestDto, observe?: 'body', reportProgress?: boolean): Observable<StoreResponseDto>;
    public apiStoreStoreLoginPost(body?: StoreRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoreResponseDto>>;
    public apiStoreStoreLoginPost(body?: StoreRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoreResponseDto>>;
    public apiStoreStoreLoginPost(body?: StoreRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StoreResponseDto>('post',`${this.basePath}/api/Store/StoreLogin`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCity 
     * @param cdUser 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreStoresWithOffersGet(cdCity?: number, cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<StoreViewUserDto>>;
    public apiStoreStoresWithOffersGet(cdCity?: number, cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreViewUserDto>>>;
    public apiStoreStoresWithOffersGet(cdCity?: number, cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreViewUserDto>>>;
    public apiStoreStoresWithOffersGet(cdCity?: number, cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreViewUserDto>>('get',`${this.basePath}/api/Store/StoresWithOffers`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCity 
     * @param cdUser 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreTrendingStoresByCityGet(cdCity?: number, cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<StoreViewUserDto>>;
    public apiStoreTrendingStoresByCityGet(cdCity?: number, cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StoreViewUserDto>>>;
    public apiStoreTrendingStoresByCityGet(cdCity?: number, cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StoreViewUserDto>>>;
    public apiStoreTrendingStoresByCityGet(cdCity?: number, cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StoreViewUserDto>>('get',`${this.basePath}/api/Store/TrendingStoresByCity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdUser 
     * @param cdCity 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStoreUserFavoritesStoresGet(cdUser?: number, cdCity?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<FavoriteStoresDto>>;
    public apiStoreUserFavoritesStoresGet(cdUser?: number, cdCity?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FavoriteStoresDto>>>;
    public apiStoreUserFavoritesStoresGet(cdUser?: number, cdCity?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FavoriteStoresDto>>>;
    public apiStoreUserFavoritesStoresGet(cdUser?: number, cdCity?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('cdUser', <any>cdUser);
        }
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<FavoriteStoresDto>>('get',`${this.basePath}/api/Store/UserFavoritesStores`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
